(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pointer-review-slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const getReviewRating = (review) => {
      const ratingElement = review.querySelector(
        '[data-score], [data-rating], .jdgm-rev__rating'
      );

      if (!ratingElement) return 0;

      const candidates = [
        ratingElement.getAttribute('data-score'),
        ratingElement.getAttribute('data-rating'),
        ratingElement.getAttribute('aria-label'),
        ratingElement.getAttribute('title'),
        ratingElement.textContent
      ];

      for (const candidate of candidates) {
        if (!candidate) continue;

        // Handles values such as "5", "5.0", or "Rated 5 out of 5".
        const match = String(candidate).match(
          /(\d+(?:\.\d+)?)\s*(?:\/\s*5|out of 5)?/i
        );

        if (match) {
          const rating = Number(match[1]);

          if (rating >= 0 && rating <= 5) {
            return rating;
          }
        }
      }

      return 0;
    };

    const sortReviewsByStars = (track) => {
      const reviews = Array.from(
        track.querySelectorAll('.jdgm-rev')
      );

      if (reviews.length < 2) return;

      // Keep reviews with equal ratings in their original order.
      const sortedReviews = reviews
        .map((review, index) => ({
          review,
          rating: getReviewRating(review),
          index
        }))
        .sort((a, b) => {
          return b.rating - a.rating || a.index - b.index;
        });

      // Leave the DOM alone when the order is already right.
      if (sortedReviews.every(({ index }, position) => index === position)) return;

      const fragment = document.createDocumentFragment();

      sortedReviews.forEach(({ review }) => {
        fragment.appendChild(review);
      });

      track.appendChild(fragment);
    };

    const updateControls = (slider) => {
      const track = slider.querySelector(
        '.jdgm-rev-widg__reviews'
      );

      if (!track) return;

      const previous = slider.querySelector(
        '[data-review-previous]'
      );

      const next = slider.querySelector(
        '[data-review-next]'
      );

      if (!previous || !next) return;

      const maximum = Math.max(
        0,
        track.scrollWidth - track.clientWidth - 2
      );

      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum;
    };

    const initialise = (slider) => {
      const track = slider.querySelector(
        '.jdgm-rev-widg__reviews'
      );

      if (!track) return;

      const reviewCount = String(track.querySelectorAll('.jdgm-rev').length);

      // Sorting moves review nodes, which the observer below sees as a change.
      // Only sort and label again when Judge.me has added or removed reviews,
      // otherwise the slider re-sorts itself on every frame.
      if (track.dataset.pointerCount === reviewCount) {
        updateControls(slider);
        return;
      }

      track.dataset.pointerCount = reviewCount;

      // Sort reviews from highest rating to lowest.
      sortReviewsByStars(track);

      track.setAttribute('role', 'region');
      track.setAttribute(
        'aria-label',
        slider.dataset.reviewLabel || 'Product reviews'
      );
      track.setAttribute('tabindex', '0');

      const reviews = Array.from(
        track.querySelectorAll('.jdgm-rev')
      );

      reviews.forEach((review, index) => {
        review.setAttribute('role', 'group');
        review.setAttribute(
          'aria-label',
          `${slider.dataset.reviewLabel || 'Review'} ${index + 1} / ${reviews.length}`
        );
      });

      if (track.dataset.pointerReady !== 'true') {
        track.dataset.pointerReady = 'true';

        track.addEventListener(
          'scroll',
          () => updateControls(slider),
          { passive: true }
        );
      }

      updateControls(slider);
    };

    // Reinitialize when Judge.me inserts or updates review markup.
    let scheduled = false;

    const scheduleStart = () => {
      if (scheduled) return;

      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        start();
      });
    };

    // Watch only the review slider itself, not the whole page: other apps add
    // hundreds of elements while the page loads.
    const observeSlider = (slider) => {
      if (slider.dataset.pointerObserved === 'true') return;

      slider.dataset.pointerObserved = 'true';

      new MutationObserver(scheduleStart).observe(slider, {
        childList: true,
        subtree: true
      });
    };

    const start = () => {
      document
        .querySelectorAll('[data-pointer-review-slider]')
        .forEach((slider) => {
          observeSlider(slider);
          initialise(slider);
        });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest(
        '[data-review-previous], [data-review-next]'
      );

      if (!button) return;

      const slider = button.closest(
        '[data-pointer-review-slider]'
      );

      const track = slider?.querySelector(
        '.jdgm-rev-widg__reviews'
      );

      if (!track) return;

      const direction = button.matches('[data-review-next]')
        ? 1
        : -1;

      track.scrollTo({
        left: track.scrollLeft +
          direction * (track.clientWidth + 10),
        behavior: 'smooth'
      });
    });

    window.addEventListener('resize', scheduleStart, {
      passive: true
    });

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', scheduleStart);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, {
        once: true
      });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pointer-visual-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const template = document.querySelector('[data-pointer-size-help-template]');
    if (!template) return;

    const injectSizeHelp = () => {
      document
        .querySelectorAll('[role="dialog"][aria-label="Size Chart"] .pify_size_chart_content[role="tabpanel"]')
        .forEach((panel) => {
          if (panel.querySelector('[data-pointer-size-help]')) return;
          panel.append(template.content.cloneNode(true));
        });
    };

    // Run at most once per frame: other apps change the page constantly.
    let queued = false;
    const queueInject = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        injectSizeHelp();
      });
    };

    // The size chart only opens (or changes tab) after a tap, so watch the
    // page for 3 seconds after each tap instead of during the whole page load.
    let observer = null;
    let stopTimer = null;
    const watchBriefly = () => {
      queueInject();
      if (!observer) {
        observer = new MutationObserver(queueInject);
        observer.observe(document.body, { childList: true, subtree: true });
      }
      clearTimeout(stopTimer);
      stopTimer = setTimeout(() => {
        observer.disconnect();
        observer = null;
      }, 3000);
    };

    document.addEventListener('click', watchBriefly, { passive: true });
    injectSizeHelp();
  })();
  } catch(e) { console.error(e); }
})();

})();
